<template>
  <div
    id="branding-template-edit"
  >
    <branding-nav />
    <branding-template-form
      :brandingTemplateId="brandingTemplateId"
    />
  </div>
</template>
<script>
import BrandingTemplateForm from '@/components/BrandingTemplateForm'
import BrandingNav from '@/components/BrandingNav'

export default {
  props: {
    'brandingTemplateId': {
      type: [ Number, String ],
      default: undefined,
      required: true
    }
  },

  components: {
    'branding-nav': BrandingNav,
    'branding-template-form': BrandingTemplateForm
  }
}
</script>




// WEBPACK FOOTER //
// src/components/BrandingTemplateEdit.vue